// extracted by mini-css-extract-plugin
module.exports = {"landscapeWarning":"landscapewarning_landscapeWarning__3Hi0I","content":"landscapewarning_content__3D8Pj"};